module.exports = __webpack_public_path__ + "img/oth17.299b708a.png";